import { Routes, Route } from "react-router-dom";
import "../src/App.css";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import NavigationProvider from "./contentApi/navigationProvider";

import DashboardLayout from "./Component/dashboardlayout";
import Login from "./Component/Login";

import ProtectedRoute from "./Component/Protectedrouter";
import PublicRoute from "./Component/publicrouter";
import ForgotPassword from "./Component/forgotpassword";

import Home from "./Component/admin/Home"
import Report from "./Component/admin/Report";
import CandidateList from "./Component/admin/candidate";
import CandidateDetails from "./Component/admin/candidatedetails";

import ActivityReport from "./Component/admin/Activityreport";
import SubscriptionMembers from "./Component/admin/Subscription";
import Payments from "./Component/admin/payment";
import Profileverify from "./Component/admin/Profileverify";

import AddPlan from "./Component/admin/AddPlan";
import EditPlan from "./Component/admin/editPlan";
import Plan from "./Component/admin/Plan";

import ComplainandReport from "./Component/admin/ComplainandReport";
import UnverifiedUser from "./Component/admin/unverifiedUser";


import "../src/tableandpagination.css"

function App() {
  return (
    <NavigationProvider>

      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar
        closeButton={false}
        toastClassName="custom-toast"
        bodyClassName="custom-toast-body"
      />

      <Routes>


        <Route element={<PublicRoute />}>
          <Route path="/" element={<Login />} />
          <Route path="/forgotpassword" element={<ForgotPassword />} />
        </Route>


        <Route element={<ProtectedRoute />}>
          <Route path="/admin" element={<DashboardLayout />}>
            <Route path="home" element={<Home />} />
            <Route path="report" element={<Report />} />

            <Route path="candidatedetails/:id" element={<CandidateDetails />} />


            <Route path="plan" element={<Plan />} />
            <Route path="add-plan" element={<AddPlan />} />
            <Route path="edit-plan/:id" element={<EditPlan />} />

            <Route path="candidates" element={<CandidateList />} />
            <Route path="attempteduser" element={<UnverifiedUser />} />
            <Route path="activityreport" element={<ActivityReport />} />
            <Route path="subscription" element={<SubscriptionMembers />} />
            <Route path="payments" element={<Payments />} />
            <Route path="profileverify" element={<Profileverify />} />

            <Route path="complainreport" element={<ComplainandReport />} />




          </Route>
        </Route>

      </Routes>

    </NavigationProvider>

  );
}

export default App;